import React, { FC, useEffect, useState } from 'react';
import {
  PageWrapper,
  GenericList,
  AdditionalUserListContent,
  FilterListInput,
  Roles,
  User,
  LoadingAnimation,
} from '@dew21/ui';
import axios from 'axios';

export const Users: FC = (props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<User[] | null>(null);
  const [filteredUsers, setFilteredUsers] = useState<User[] | null>(null);

  const fetchUsers = () => {
    return axios.get('/api/users');
  };

  useEffect(() => {
    setIsLoading(true);
    fetchUsers().then((response) => {
      setUsers(response.data);
      setFilteredUsers(response.data);
      setIsLoading(false);
    }).catch((error) => {
      console.log(error);
      setIsLoading(false);
    });
  }, []);

  return <PageWrapper breadCrumb={[{ title: 'Benutzer', path: '/users' }]} marginal={{
    items: [
      {
        text: 'Neuen Benutzer hinzufügen',
        icon: 'add-user',
        route: '/users/add',
      },
    ],
  }}>

    {
      (users && users.length > 0) && <FilterListInput
        id={'filter-users'}
        label={'Benutzersuche'}
        onChange={(value: string | null) => {
          if (value && users) {
            const condition = users.filter((user) => {
              const matchingString = `${user.firstName} ${user.familyName}`;
              if (matchingString.toLowerCase().includes(value.toLowerCase())) {
                return user;
              }
            }).filter((user) => user !== null) || users;
            setFilteredUsers(condition);
          } else {
            setFilteredUsers(users);
          }
        }}
        placeholder={'Vorname Nachname'} />
    }

    {
      filteredUsers && filteredUsers.length > 0 && !isLoading ?
        <GenericList
          displayColumnNames={true}
          collapsible={true}
          additionalRenderFn={(item: User) => {
            return <AdditionalUserListContent
              item={item}
              editRoute={'/users/{id}'} />;
          }}
          columns={[
            { name: 'firstName', displayName: 'Vorname', sortable: true },
            { name: 'familyName', displayName: 'Nachname', sortable: true },
            { name: 'dewDepartment', displayName: 'Abteilung', sortable: false },
            {
              name: 'role', displayName: 'Role', sortable: true, formatFn: (value: string) => {
                switch (value.toString()) {
                  case Roles.ADMIN.toString():
                    return 'Administrator';
                  case Roles.SUPER_USER.toString():
                    return 'Vertriebsleiter';
                  case Roles.USER.toString():
                    return 'Vertriebsmitarbeiter';
                  default:
                    return 'Vertriebsmitarbeiter';
                }
              },
            },
          ]}
          items={filteredUsers}
          countLabel={`${filteredUsers.length} User gefunden`} /> : 'Keine Benutzer gefunden!'
    }
    {
      isLoading && <LoadingAnimation overlay transparent />
    }
  </PageWrapper>;
};
